import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  pageContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    background: "white",
    minHeight: "100vh",
    padding: theme.spacing(3, 0),
  },
  navigateBack: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    position: "absolute",
    left: "16px",
    top: "16px",
    color: grey[800],
    fontWeight: 500,
  },
  arrowBack: {
    color: grey[600],
    marginRight: "12px",
  },
}));
